<template>
  <div class="footer shadow" :style="footerStyle">
    <slot></slot>
  </div>
</template>

<script setup>
const props = defineProps({
  footerStyle: {
    type: Object,
    default: () => {}
  }
})
</script>
<style scoped lang="scss">
.footer {
  background: var(--card-bg-color);
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  position: fixed;
  bottom: var(--app-fixed-bottom-offset, 0px);
  width: calc(100% - 32px);
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 1200;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.02);
}
</style>
